import { ColorModeScript } from '@chakra-ui/react';
import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorker from './serviceWorker';

const rootElement = document.getElementById('root');
// TODO: Uncomment below to receive data from the Dashboard
const dashboardDataset = rootElement.dataset.params ? JSON.parse(rootElement.dataset.params) : undefined;
// console.log(dashboardDataset);

ReactDOM.render(
  <StrictMode>
    <ColorModeScript />
    <App dashboardDataset={dashboardDataset} />
  </StrictMode>,
  rootElement
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
